import i18n from '@/natives/libs/i18n';
import useDialog from './useDialog';

const styles = `
.hpp-message {
  display: flex;
  width: 360px;
  flex-direction: column;
  padding: 24px;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.2), 0 16px 32px 0 rgba(0, 0, 0, 0.12);
}

.hpp-message__main {
  flex: 1;
  margin: 12px 0 24px 16px;
  display: flex;
}

.hpp-message__main img {
  width: 40px;
  height: 40px;
}

.hpp-message__main p {
  margin-left: 16px;
  display: flex;
  flex-direction: column;
}

.hpp-message__title {
  color: #1a1a1a;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  word-break: break-word;
}

.hpp-message__msg {
  max-height: 300px;
  line-height: 20px;
  word-break: break-word;
  margin-bottom: 10px;
  color: #4d4d4d;
}

.hpp-message__footer {
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
}

.hpp-message__footer button {
  min-width: 96px;
}
`;
const elStyle = document.createElement('style');
elStyle.innerHTML = styles;
document.head.appendChild(elStyle);

const ICON_MAP = {
  error: `data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+Y29tbW9uX2ZlZWRiYWNrX2Vycm9yX3NtPC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnIGlkPSJjb21tb25fZmVlZGJhY2tfZXJyb3Jfc20iIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00LCAtNCkiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTEyLDQgQzE2LjQxODI3OCw0IDIwLDcuNTgxNzIyIDIwLDEyIEMyMCwxNi40MTgyNzggMTYuNDE4Mjc4LDIwIDEyLDIwIEM3LjU4MTcyMiwyMCA0LDE2LjQxODI3OCA0LDEyIEM0LDcuNTgxNzIyIDcuNTgxNzIyLDQgMTIsNCBaIE05LjUzMDMzMDA5LDguNDY5NjY5OTEgQzkuMjM3NDM2ODcsOC4xNzY3NzY3IDguNzYyNTYzMTMsOC4xNzY3NzY3IDguNDY5NjY5OTEsOC40Njk2Njk5MSBDOC4xNzY3NzY3LDguNzYyNTYzMTMgOC4xNzY3NzY3LDkuMjM3NDM2ODcgOC40Njk2Njk5MSw5LjUzMDMzMDA5IEw4LjQ2OTY2OTkxLDkuNTMwMzMwMDkgTDEwLjkzOTMzOTgsMTIgTDguNDY5NjY5OTEsMTQuNDY5NjY5OSBDOC4xNzY3NzY3LDE0Ljc2MjU2MzEgOC4xNzY3NzY3LDE1LjIzNzQzNjkgOC40Njk2Njk5MSwxNS41MzAzMzAxIEM4Ljc2MjU2MzEzLDE1LjgyMzIyMzMgOS4yMzc0MzY4NywxNS44MjMyMjMzIDkuNTMwMzMwMDksMTUuNTMwMzMwMSBMOS41MzAzMzAwOSwxNS41MzAzMzAxIEwxMiwxMy4wNjA2NjAyIEwxNC40Njk2Njk5LDE1LjUzMDMzMDEgQzE0Ljc2MjU2MzEsMTUuODIzMjIzMyAxNS4yMzc0MzY5LDE1LjgyMzIyMzMgMTUuNTMwMzMwMSwxNS41MzAzMzAxIEMxNS44MjMyMjMzLDE1LjIzNzQzNjkgMTUuODIzMjIzMywxNC43NjI1NjMxIDE1LjUzMDMzMDEsMTQuNDY5NjY5OSBMMTUuNTMwMzMwMSwxNC40Njk2Njk5IEwxMy4wNjA2NjAyLDEyIEwxNS41MzAzMzAxLDkuNTMwMzMwMDkgQzE1LjgyMzIyMzMsOS4yMzc0MzY4NyAxNS44MjMyMjMzLDguNzYyNTYzMTMgMTUuNTMwMzMwMSw4LjQ2OTY2OTkxIEMxNS4yMzc0MzY5LDguMTc2Nzc2NyAxNC43NjI1NjMxLDguMTc2Nzc2NyAxNC40Njk2Njk5LDguNDY5NjY5OTEgTDE0LjQ2OTY2OTksOC40Njk2Njk5MSBMMTIsMTAuOTM5MzM5OCBaIiBpZD0iQ29sb3IiIGZpbGw9IiNFODExMjMiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=`
};

/**
 * @type {import('./types').useMessage}
 */
function useMessage(options) {
  return new Promise((resolve, reject) => {
    const elDialog = document.createElement('div');
    elDialog.classList.add('hpp-message');
    const dialog = useDialog(elDialog, { destroyOnClose: true });

    const elDialogMain = document.createElement('main');
    elDialogMain.classList.add('hpp-message__main');
    const elDialogFooter = document.createElement('footer');
    elDialogFooter.classList.add('hpp-message__footer');
    const elDialogIcon = document.createElement('img');
    const elDialogContent = document.createElement('p');
    const elDialogTitle = document.createElement('span');
    elDialogTitle.classList.add('hpp-message__title');
    const elDialogMsg = document.createElement('span');
    elDialogMsg.classList.add('hpp-message__msg');

    elDialog.appendChild(elDialogMain);
    elDialog.appendChild(elDialogFooter);
    elDialogMain.appendChild(elDialogIcon);
    elDialogMain.appendChild(elDialogContent);
    elDialogContent.appendChild(elDialogMsg);

    elDialogIcon.src = ICON_MAP[options.type];

    if (Object.prototype.hasOwnProperty.call(options, 'title')) {
      elDialogTitle.textContent = options.title;
      elDialogContent.insertBefore(elDialogTitle, elDialogContent.children[0]);
    }

    elDialogMsg.textContent = options.message;

    const ok = (action) => {
      dialog.close();
      resolve(action);
    };
    const cancel = () => {
      dialog.close();
      reject();
    };

    if (!options.buttons || !Array.isArray(options.buttons)) {
      const elDialogOk = document.createElement('button');
      elDialogOk.classList.add('hpp-button--primary');
      elDialogOk.textContent = i18n.t('ok');
      elDialogOk.addEventListener('click', ok);
      elDialogFooter.appendChild(elDialogOk);
    } else {
      options.buttons.forEach((item) => {
        const elDialogButton = document.createElement('button');
        elDialogButton.classList.add(`hpp-button--${item.type}`);
        elDialogButton.textContent = item.name;
        if (item.type === 'primary') {
          elDialogButton.addEventListener('click', () => ok(item.action));
        } else {
          elDialogButton.addEventListener('click', cancel);
        }
        elDialogFooter.appendChild(elDialogButton);
      });
    }

    dialog.open();
  });
}

export default useMessage;
